import { Button } from 'antd';
import { Modal } from '../basics';
import classnames from 'classnames';
import styles from './confirmModal.module.scss';
import type { FC, ReactNode, CSSProperties } from 'react';
import { ModalProps } from '../basics';

export type StaticRenderModalConfig = Pick<ModalProps, 'onCancel'>;

export interface ConfirmModalProps extends Omit<ModalProps, 'children'> {
  type: 'info' | 'alert',
  titleStyle?: CSSProperties
  title?: ReactNode;
  content: string | ReactNode | ((config: StaticRenderModalConfig) => ReactNode);
  footer?: ReactNode;
  onOkText?: ReactNode;
  onCancelText?: ReactNode;
  onOk?: () => void;
  className?: string;
  titleProps?: {
    useDefaultColor?: boolean; // 是否使用默认颜色
    align?: 'left' | 'center' | 'right';
  }
  footerProps?: {
    ghost?: boolean;
  }
}

export type ConfirmModalFnProps = Omit<ConfirmModalProps, 'type'>

export interface FooterProps extends Pick<ConfirmModalProps, 'footer' | 'onCancel' | 'onOkText' | 'onCancelText' | 'onOk'> {
  ghost?: boolean
}
const InfoFooter: FC<FooterProps> = ({ footer, onCancel, onOkText, ghost = true, onOk }) => {

  const prefixCls = 'web_components_modal';

  if (footer === null) {
    return footer;
  }

  if (footer) {
    return <>{footer}</>;
  }

  return (
    <Button
      type='primary'
      ghost={ghost}
      className={`${prefixCls}_info_footer_button_ok`}
      onClick={() => {
        onOk?.()
        onCancel?.()
      }}
    >
      {onOkText || 'OK'}
    </Button>
  )

};
const AlertFooter: FC<FooterProps> = ({ footer, onCancel, onOk, onOkText, onCancelText }) => {
  
  const prefixCls = 'web_components_modal';

  if (footer === null) {
    return footer;
  }

  if (footer) {
    return <>{footer}</>;
  }

  return (
    <>
      <Button
        type='primary'
        ghost
        className={`${prefixCls}_confirm_footer_button_cancel`}
        onClick={onCancel}
      >
        {onCancelText || 'Cancel'}
      </Button>
      <Button
        type='primary'
        className={`${prefixCls}_confirm_footer_button_ok`}
        onClick={onOk}
      >
        {onOkText || 'OK'}
      </Button>
    </>
  )
};

const ConfirmModal: FC<ConfirmModalProps> = ({ type, title, titleStyle, content, footer, onCancel, className, onCancelText, onOkText, wrapClassName, onOk, footerProps, titleProps, ...restModalProps }) => {
  const prefixCls = 'web_components_modal';

  const modalProps = {
    ...restModalProps,
    onCancel
  };

  const _titleProps = { ...titleProps }
  const _footerProps = { onCancel, footer, onCancelText, onOkText, onOk, ...footerProps };
  const renderFooterMap: { [type: string]: ReactNode; } = {
    info: <InfoFooter {..._footerProps} />,
    alert: <AlertFooter {..._footerProps} />
  };

  const footerContent = renderFooterMap[type] || <InfoFooter {..._footerProps} />;

  const renderFooter = () => {
    if (footer === null) {
      return null;
    }
    if (footer) {
      return footer;
    }
    return (
      <div className={`${prefixCls}_footer`}>
        {footerContent}
      </div>
    )
  }

  console.log('restModalProps', className)

  return (
    <Modal
      {...modalProps}
      className={
        classnames(
          styles.web_components_modal_confirm_common,
          className,
        )}
      wrapClassName={
        classnames(
          `web_components_modal_${type}`,
          wrapClassName
        )
      }
    >
      {title && (
        <div
          style={{
            textAlign: _titleProps?.align || 'center',
            ...titleStyle,
          }}
          className={classnames(
            `${prefixCls}_header`,
            {
              [`${prefixCls}_header_default_color`]: _titleProps?.useDefaultColor
            }
          )}>
          {title}
        </div>
      )}
      <div
        className={`${prefixCls}_body`}>
        {
          typeof content === 'function' ? content?.({ onCancel }) : content
        }
      </div>
      {
        renderFooter()
      }

    </Modal>
  );
};
export default ConfirmModal;